<form (ngSubmit)="next()" [formGroup]="form">
    <div class="cp5" fxLayout="row wrap" fxLayoutAlign="flex-start center">
        <div fxFlex="33" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('staffNm')"

                    [label]="'nom_prenom'"
            ></app-text-field>
        </div>
        <div fxFlex="33" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('officialsId')"
                    [label]="'iden_unique_fonctionaire'"
            ></app-text-field>
        </div>
        <div fxFlex fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('staffDeptNm')"
                    [label]="'departrement'"
            ></app-text-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('positionNm')"
                    [label]="'Fonction'"
            ></app-text-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field

                    [control]="get('telNo')"
                    [label]="'tel_fixe'"
                    [number]="true"
            ></app-text-field>
        </div>

        <div fxFlex="50" fxFlex.lt-md="100">

            <app-text-field
                    [control]="get('faxNo')" [label]="'fax'" [number]="true"></app-text-field>
        </div>
        <div fxFlex="50" fxFlex.lt-md="100">
            <app-text-field
                    [control]="get('mtelNo')"
                    [label]="'tel_port'"
                    [number]="true"
            ></app-text-field>
        </div>
    </div>
    <div fxLayoutAlign="end end" mat-dialog-actions>
        <app-spinner-container>
            <button color="primary" mat-raised-button>
                <span translate>submit</span>
            </button>
        </app-spinner-container>
    </div>
</form>
